@if (contentOnEditID != content.id) {
  <section [ngClass]="{'dark': (darkmode.isDarkMode | async), 'light': !(darkmode.isDarkMode | async)}" [class.customLightmode]="customLightmode" [class.notificationHightlight]="hightlight" [class.internalNote]="content?.art?.id == 4 && content?.isMail == false">
    <div class="mh-header">
      @if (!isLoading) {
        <div class="userText" (click)="isOpen = !isOpen">
          @if (content?.isMail == true) {
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="envelope" class="svg-inline--fa fa-envelope" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 352c-16.53 0-33.06-5.422-47.16-16.41L0 173.2V400C0 426.5 21.49 448 48 448h416c26.51 0 48-21.49 48-48V173.2l-208.8 162.5C289.1 346.6 272.5 352 256 352zM16.29 145.3l212.2 165.1c16.19 12.6 38.87 12.6 55.06 0l212.2-165.1C505.1 137.3 512 125 512 112C512 85.49 490.5 64 464 64h-416C21.49 64 0 85.49 0 112C0 125 6.01 137.3 16.29 145.3z"></path></svg>
          }
          @if (content?.art?.id == 4 && content?.isMail == false) {
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="message" class="svg-inline--fa fa-message fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M511.1 63.1v287.1c0 35.25-28.75 63.1-64 63.1h-144l-124.9 93.68c-7.875 5.75-19.12 .0497-19.12-9.7v-83.98h-96c-35.25 0-64-28.75-64-63.1V63.1c0-35.25 28.75-63.1 64-63.1h384C483.2 0 511.1 28.75 511.1 63.1z"></path></svg>
          }
          @if (content?.art?.id == 3 && content?.isMail == false) {
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-tie" class="svg-inline--fa fa-user-tie fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M224 256c70.75 0 128-57.25 128-128s-57.25-128-128-128S96 57.25 96 128S153.3 256 224 256zM314.7 308.8l-42.72 171.1L240 344l32-56h-96l32 56l-31.99 135.1L133.3 308.8C56.91 326.9 0 395.4 0 477.3C0 496.5 15.52 512 34.66 512H413.3C432.5 512 448 496.5 448 477.3C448 395.4 391.1 326.9 314.7 308.8z"></path></svg>
          }
          @if (content?.art?.id == 7 && content?.isMail == false) {
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M0 80L0 229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>
          }
          <div>{{content?.userText}}</div>
        </div>
      }
      @if (isLoading) {
        <ion-skeleton-text animated style="width: 30%; max-width: 100px;"></ion-skeleton-text>
      }
      @if (!isLoading) {
        <div class="workstep-content-actions" style="display: flex;">
          @if (authSrv.includesRole('employee')) {
            <div class="hover-bttn customDarkmodeBttn" (click)="openReadState($event)">
              @if (!content?.readByAll) {
                <ion-icon name="fa-check" style="opacity: 0.5;"></ion-icon>
              }
              @if (content?.readByAll) {
                <ion-icon name="fa-check-double" style="color: var(--blue);"></ion-icon>
              }
            </div>
          }
          <!-- <div class="hover-bttn customDarkmodeBttn" *ngIf="(darkmode.isDarkMode | async)" (click)="customLightmode = !customLightmode">
          <ion-icon [ngStyle]="{transform: !customLightmode ? 'rotate(0deg)' : 'rotate(180deg)'}" name="fa-darkmode"></ion-icon>
        </div> -->
        @if (showEditHeader || (content.from.type == 2)) {
          <div class="hover-bttn" (click)="openEditOptions($event)">
            <ion-icon name="fa-ellipsis-vertical"></ion-icon>
          </div>
        }
      </div>
    }
    @if (isLoading) {
      <ion-skeleton-text animated style="width: 20px"></ion-skeleton-text>
    }
  </div>
  <div class="htmlContent" [class.open]="contentHeight > 80" [class.close]="contentHeight == 60" [class.noShowMore]="contentHeight < 60">
    @if (!isLoading) {
      <div #htmlContent class="mainHtmlContent"  [innerHTML]="content?.htmlText | safeHtml" [ngStyle]="{maxHeight: contentHeight > 60 && isOpen ? contentHeight + 'px' : 60 + 'px'}">
      </div>
    }
    <div class="show-more" (click)="isOpen = !isOpen">
      <div>
        {{isOpen ? 'Weniger anzeigen' : 'Mehr anzeigen'}}
      </div>
      <svg [ngStyle]="{transform: 'rotate(' + (isOpen ? 180 : 0) + 'deg)'}" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="angle-down" class="svg-inline--fa fa-angle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z"></path></svg>
    </div>
    <app-user-information #userInformation [employeeInformationPosition]="employeeInformationPosition" [class.userInformationAnimation]="employeeInformationPosition?.animation" [class.userInformationHidden]="!employeeInformationPosition.active" [class.userInformationShow]="employeeInformationPosition.active" [ngStyle]="{'bottom.px': employeeInformationPosition?.y, 'left.px': employeeInformationPosition?.x}"></app-user-information>
  </div>
  @if (withLine) {
    <div class="connect-line"></div>
  }
  @if (isLoading) {
    <div class="htmlContent isLoading">
      @if (isLoading) {
        <ion-skeleton-text animated style="width: 40%;"></ion-skeleton-text>
      }
      @if (isLoading) {
        <ion-skeleton-text animated style="width: 60%;"></ion-skeleton-text>
      }
      @if (isLoading) {
        <ion-skeleton-text animated style="width: 70%;"></ion-skeleton-text>
      }
      @if (isLoading) {
        <ion-skeleton-text animated style="width: 30%;"></ion-skeleton-text>
      }
    </div>
  }
</section>
}
@if (contentOnEditID == content.id) {
  <app-content-edit-popup [isNew]="false" [content]="content" (closed)="editClosed()" [showSettingsSettings]="showEditHeader"></app-content-edit-popup>
}
